import React, { useEffect, useRef, useState } from "react";
import PptxGenJS from "pptxgenjs";
import html2canvas from "html2canvas";

import "./PdfPage.css";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TemplatePage from "./TemplatePage";
import DriveAnalyticsPdf from "./DriveAnalyticsPdf";
import ChargeAnalyticsPdf from "./ChargeAnalyticsPdf";
import ChargeFifth from "./ChargeFifth";
import PdfForteenPdf from "./PdfForteenPdf";
import PdfFifteen from "./PdfFifteen";
import PdfEigthPage from "./PdfEigthPage";
import FaultFirstPart from "./FaultFirstPart";
import FaultSecondPart from "./FaultSecondPart";
import FaultThirdPart from "./FaultThirdPart";
import FaultForthPart from "./FaultForthPart";
import FaultFifthPart from "./FaultFifthPart";
import Critical from "./Critical";
import EnergyAnalyticsPdf from "./EnergyAnalytics";
import EnergyChart from "./EnergyChart";
import BubbleChart from "./Bubble";

// import './App.css'; // Ensure you have your CSS file`

export default function PdfFirstPage_Bus(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const targetRef = useRef();

  const [showPdf, setShowPdf] = useState(false);
  const [startdate, setStartdate] = useState(false);
  const [enddate, setEnddate] = useState(false);
  const [refs, setRefs] = useState({});
  // const [selectTemp, setSelectTemp] = useState(props.selectedtemp);

  useEffect(() => {
    const formattedstartDate = formatDate(gloablfilter.startDate);
    setStartdate(formattedstartDate);
    const formattedendDate = formatDate(gloablfilter.endDate);
    setEnddate(formattedendDate);
  }, [gloablfilter]);

  function formatDate(dateString) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    // Create a Date object from the provided string
    const date = new Date(dateString);
    // Get the day, month, and year from the Date object
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    // Add the ordinal suffix to the day
    const dayWithSuffix = addOrdinalSuffix(day);
    // Format the date string
    const formattedDate = `${dayWithSuffix} ${months[monthIndex]}, ${year}`;
    return formattedDate;
  }

  function addOrdinalSuffix(day) {
    if (day === 1 || day === 21 || day === 31) {
      return day + "st";
    } else if (day === 2 || day === 22) {
      return day + "nd";
    } else if (day === 3 || day === 23) {
      return day + "rd";
    } else {
      return day + "th";
    }
  }

  useEffect(() => {
    if (props.buttonClick === "true") handleClick();
  }, [props.buttonClick]);

  useEffect(() => {
    // Add styles to the body when the component mounts
    // document.html.style.overFlow = 'hidden';
    window.scrollTo(0, 0);
    document.documentElement.style.overflow = "hidden";

    // Cleanup styles when the component unmounts
    return () => {
      document.documentElement.style.overflow = "";
      // document.body.style.overFlow = 'auto';
      // document.body.style.color = '';
    };
  }, []);

  const handleClick = () => {
    // setShowPdf(true);
    setTimeout(handleDownload, 5000);
    setShowPdf(true);
    // setShowPdf(false);
  };

  const slide1Images = [
    { ref: refs.logo, position: { x: 8.1, y: 0.25, w: 1.7, h: 0.5 } }, // Header (logo)
    { ref: refs.middleImage, position: { x: 3.92, y: 0.91, w: 6.06, h: 4.14 } }, // Middle image
    { ref: refs.footerImage, position: { x: 0.42, y: 5.05, w: 1.7, h: 0.5 } }, // Footer image
    // Add more images here with their respective refs and positions
  ];

  const slide2Images = [
    { ref: refs.logo, position: { x: 8.1, y: 0.25, w: 1.7, h: 0.5 } }, // Header (logo)
    { ref: refs.footerImage, position: { x: 0.42, y: 5.05, w: 1.7, h: 0.5 } }, // Footer image
    {
      ref: refs.footerRightImageRef,
      position: { x: 7.8, y: 5.02, w: 2.2, h: 0.6 },
    }, // Footer corner image
    // Add more images here with their respective refs and positions
  ];
  const slide4Images = [
    { ref: refs.logo, position: { x: 8.1, y: 0.25, w: 1.7, h: 0.5 } }, // Header (logo)
    { ref: refs.footerImage, position: { x: 0.42, y: 5.05, w: 1.7, h: 0.5 } }, // Footer image
    // Add more images here with their respective refs and positions
  ];

  const slide3Images = [
    {
      ref: refs.lastPageImageRef,
      position: { x: 0.6, y: 0.6, w: 9.06, h: 4.4 },
    }, // Footer corner image
  ];

  const handleDownload = async () => {
    const pptx = new PptxGenJS();
    const calculateHeight1 = (rowCount, maxRows = 20, maxHeight = 4.1) => {
      return (rowCount / maxRows) * maxHeight;
    };
    // First Slide
    const slide1 = pptx.addSlide();
    const addImagesToSlide = async (slide, imagesToConvert) => {
      for (const image of imagesToConvert) {
        if (image.ref) {
          try {
            const canvas = await html2canvas(image.ref);
            const imgData = canvas.toDataURL("image/png");
            slide.addImage({ data: imgData, ...image.position });
          } catch (error) {
            console.error("Error converting image to canvas:", error);
            // Handle error as needed
          }
        }
      }
    };
    const calculateHeight = (rowCount, maxRows = 20, maxHeight = 4.1) => {
      return (rowCount / maxRows) * maxHeight;
    };
    const calculateHeight2 = (rowCount, maxRows = 16, maxHeight = 4.1) => {
      return (rowCount / maxRows) * maxHeight;
    };
    slide1.addText("CESL E-Buses", {
      x: 0.5,
      y: 2,
      fontSize: 16,
      color: "black",
      bold: true,
    });
    slide1.addText("Performance and Trend Analytics", {
      x: 0.5,
      y: 2.5,
      fontSize: 12,
      color: "#607ec8",
    });
    slide1.addText(`Data considered for : ${startdate} - ${enddate}`, {
      x: 0.5,
      y: 3,
      fontSize: 11,
      color: "#607ec8",
    });
    slide1.addText("Data Analytics Team", {
      x: 0.5,
      y: 3.5,
      fontSize: 12,
      color: "#607ec8",
    });
    slide1.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    await addImagesToSlide(slide1, slide1Images);

    // Second Slide
    const slide2 = pptx.addSlide();
    // Retrieve data from DriveAnalyticsPdf component
    const driveAnalyticsPdfData = refs.driveAnalyticsPdf.getDataForSlide();
    await addImagesToSlide(slide2, slide2Images);
    const tableElement = document.querySelector(".pdftable");
    const noDataElement = document.querySelector(".no_data");
    if (tableElement) {
      try {
        const canvas = await html2canvas(tableElement, {
          scale: 2, // Increase scale for higher resolution
          useCORS: true, // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide2.addImage({ data: imgData, x: 0.5, y: 0.86, w: 9, h: 2.5 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing table as image:", error);
      }
    } else if (noDataElement) {
      try {
        const canvas = await html2canvas(noDataElement, {
          // scale: 2, // Increase scale for higher resolution
          // useCORS: true // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide2.addImage({ data: imgData, x: 0.5, y: 1, w: 9.3, h: 1.65 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing NoData component as image:", error);
      }
    } else {
      console.error("Table element or NoData element not found");
    }
    slide2.addText("Drive Analytics Summary :", {
      x: 0.5,
      y: 0.5,
      fontSize: 16,
      color: "#002060",
      bold: true,
    });
    slide2.addText(`${startdate} - ${enddate}`, {
      x: 3,
      y: 0.5,
      fontSize: 11,
      color: "black",
      bold: true,
    });
    slide2.addText(
      `Total ${
        driveAnalyticsPdfData?.totalVehCount || 0
      } driven buses are on road with ${
        driveAnalyticsPdfData?.totalDistance || 0
      } cumulative kms logged.`,
      { x: 0.5, y: 4.28, w: 9.3, h: 0.48, fontSize: 12, color: "black" }
    );
    slide2.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });

    //Bubble.js
    const slide10 = pptx.addSlide();
    const bubbleElementSLide10 = document.querySelector("#bubble-chart");
    const sohgraphnote = document.querySelector("#sohgraphnote");
    // const bubblecharttext = document.querySelector("#bubblecharttext");
    const bubble = refs.bubble.getDataForSlide();
    const { packTotalCount, maxCount } = bubble;
    if (sohgraphnote) {
      try {
        const canvas = await html2canvas(sohgraphnote, {
          scale: 2, // Increase scale for higher resolution
          useCORS: true, // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide10.addImage({ data: imgData, x: 0.5, y: 4.25, w: 9.01, h: 0.3 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing table as image:", error);
      }
    }
    if (bubbleElementSLide10) {
      try {
        const canvas = await html2canvas(bubbleElementSLide10, {
          scale: 2, // Increase scale for higher resolution
          useCORS: true, // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide10.addImage({ data: imgData, x: 0.5, y: 0.79, w: 6.01, h: 3.42 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing table as image:", error);
      }
    }
    // if (bubblecharttext) {
    //   try {
    //     const canvas = await html2canvas(bubbleElementSLide10, {
    //       scale: 2, // Increase scale for higher resolution
    //       useCORS: true, // Enable cross-origin resource sharing if needed
    //     });
    //     const imgData = canvas.toDataURL("image/png");
    //     slide10.addImage({ data: imgData, x: 6.5, y: 3.79, w: 3.01, h: 1 }); // Adjust the position and size as needed
    //   } catch (error) {
    //     console.error("Error capturing table as image:", error);
    //   }
    // }
    // else if (noDataElementSlide3) {
    //   try {
    //     const canvas = await html2canvas(noDataElement, {
    //       scale: 2, // Increase scale for higher resolution
    //       useCORS: true, // Enable cross-origin resource sharing if needed
    //     });
    //     const imgData = canvas.toDataURL("image/png");
    //     slide3.addImage({ data: imgData, x: 0.5, y: 1, w: 9.3, h: 2 }); // Adjust the position and size as needed
    //   } catch (error) {
    //     console.error("Error capturing NoData component as image:", error);
    //   }
    // }
    else {
      console.error("Table element or NoData element not found");
    }
    slide10.addText("SOH Degradation :", {
      x: 0.6,
      y: 0.5,
      fontSize: 16,
      color: "#002060",
      bold: true,
    });
    slide10.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    slide10.addText(
      `Out of ${packTotalCount} buses, ${maxCount} are showing the`,
      { x: 6.5, y: 2.6, fontSize: 12, color: "black" }
    );
    slide10.addText(`degredation inSOH.`, {
      x: 6.5,
      y: 2.8,
      fontSize: 12,
      color: "black",
    });
    await addImagesToSlide(slide10, slide2Images);

    // Third Slide(Charge)
    const slide3 = pptx.addSlide();
    const tableElementSLide3 = document.querySelector("#slide3Table");
    const noDataElementSlide3 = document.querySelector(".no_data_slide3");
    const chargeFifthData = refs.chargeFifth.getDataForSlide();

    if (tableElementSLide3) {
      try {
        const canvas = await html2canvas(tableElementSLide3, {
          scale: 2, // Increase scale for higher resolution
          useCORS: true, // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide3.addImage({ data: imgData, x: 0.5, y: 0.79, w: 9.01, h: 3.72 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing table as image:", error);
      }
    } else if (noDataElementSlide3) {
      try {
        const canvas = await html2canvas(noDataElement, {
          scale: 2, // Increase scale for higher resolution
          useCORS: true, // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide3.addImage({ data: imgData, x: 0.5, y: 1.5, w: 9.3, h: 0.4 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing NoData component as image:", error);
      }
    } else {
      console.error("Table element or NoData element not found");
    }
    slide3.addText("Charge Analytics Summary :", {
      x: 0.6,
      y: 0.5,
      fontSize: 16,
      color: "#002060",
      bold: true,
    });
    slide3.addText(`${startdate} - ${enddate}`, {
      x: 3.3,
      y: 0.5,
      fontSize: 11,
      color: "black",
      bold: true,
    });
    slide3.addText(
      `There are ${
        chargeFifthData?.vinCount || 0
      } vehicles which are showing abnormal max cell temperature during charging. For more details, please refer page no 6.`,
      { x: 0.5, y: 4.5, w: 9.3, h: 0.5, fontSize: 12, color: "black" }
    );
    slide3.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    await addImagesToSlide(slide3, slide2Images);

    // Slide Four

    const slide4 = pptx.addSlide();
    const faultTableElementSlide4 = document.querySelector(
      "#slide_4_table_fault"
    );
    const occurDataTableElementSlide4 = document.querySelector(
      "#slide_4_table_occurance"
    );
    const faultTableNoDataElementSlide4 = document.querySelector(
      ".no_data_slide_fault_slide_4"
    );
    const occurDataNoDataElementSlide4 = document.querySelector(
      ".no_data_slide_occurance_4"
    );
    if (faultTableElementSlide4) {
      try {
        const canvas = await html2canvas(faultTableElementSlide4, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide4.addImage({ data: imgData, x: 0.5, y: 1, w: 4.5, h: 3.4 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    } else if (faultTableNoDataElementSlide4) {
      try {
        const canvas = await html2canvas(faultTableNoDataElementSlide4, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide4.addImage({ data: imgData, x: 0.3, y: 1, w: 4.5, h: 2 }); // Adjust the position and size as needed
      } catch (error) {
        console.error(
          "Error capturing NoData component for fault table as image:",
          error
        );
      }
    } else {
      console.error("Fault table element or NoData element not found");
    }

    // Capture second table as image
    if (occurDataTableElementSlide4) {
      try {
        const canvas = await html2canvas(occurDataTableElementSlide4, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide4.addImage({ data: imgData, x: 5.23, y: 1, w: 4.5, h: 3.4 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing occurrence table as image:", error);
      }
    } else if (occurDataNoDataElementSlide4) {
      try {
        const canvas = await html2canvas(occurDataNoDataElementSlide4, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide4.addImage({ data: imgData, x: 5, y: 1, w: 4.5, h: 2 }); // Adjust the position and size as needed
      } catch (error) {
        console.error(
          "Error capturing NoData component for occurrence table as image:",
          error
        );
      }
    } else {
      console.error("Occurrence table element or NoData element not found");
    }

    slide4.addText("Fault Analytics:", {
      x: 0.5,
      y: 0.5,
      fontSize: 16,
      color: "#002060",
      bold: true,
    });
    slide4.addText(`${startdate} - ${enddate}`, {
      x: 2,
      y: 0.5,
      fontSize: 11,
      color: "black",
      bold: true,
    });
    slide4.addText(
      `The vehicles with maximum occurrences of current imbalance mentioned above can be investigated.`,
      { x: 0.5, y: 4.6, fontSize: 12, color: "black" }
    );
    slide4.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    await addImagesToSlide(slide4, slide2Images);

    // Energy Gauge Chart
    const slide16 = pptx.addSlide();
    const energyGaugeSlide16 = document.querySelector("#gauge_collection");
    const energyTitleSlide16 = document.querySelector("#energy-title");
    const energyTableSlide16 = document.querySelector("#energy-table");
    // const bubble = refs.bubble.getDataForSlide();

    if (energyGaugeSlide16) {
      try {
        const canvas = await html2canvas(energyGaugeSlide16, {
          scale: 2, // Increase scale for higher resolution
          useCORS: true, // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide16.addImage({ data: imgData, x: 0.6, y: 1.32, w: 9.01, h: 1.29 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing table as image:", error);
      }
    }
    if (energyTitleSlide16) {
      try {
        const canvas = await html2canvas(energyTitleSlide16, {
          scale: 2, // Increase scale for higher resolution
          useCORS: true, // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide16.addImage({ data: imgData, x: 0.6, y: 0.9, w: 9.01, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing table as image:", error);
      }
    }
    if (energyTableSlide16) {
      try {
        const canvas = await html2canvas(energyTableSlide16, {
          scale: 2, // Increase scale for higher resolution
          useCORS: true, // Enable cross-origin resource sharing if needed
        });
        const imgData = canvas.toDataURL("image/png");
        slide16.addImage({ data: imgData, x: 0.6, y: 2.8, w: 9.01, h: 2 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing table as image:", error);
      }
    }
    // else if (noDataElementSlide3) {
    //   try {
    //     const canvas = await html2canvas(noDataElement, {
    //       scale: 2, // Increase scale for higher resolution
    //       useCORS: true, // Enable cross-origin resource sharing if needed
    //     });
    //     const imgData = canvas.toDataURL("image/png");
    //     slide3.addImage({ data: imgData, x: 0.5, y: 1, w: 9.3, h: 2 }); // Adjust the position and size as needed
    //   } catch (error) {
    //     console.error("Error capturing NoData component as image:", error);
    //   }
    // }
    else {
      console.error("Table element or NoData element not found");
    }
    slide16.addText(
      `Energy Consumption Breakdown : ${startdate} - ${enddate} `,
      {
        x: 0.5,
        y: 0.5,
        fontSize: 16,
        color: "#002060",
        bold: true,
      }
    );
    slide16.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    await addImagesToSlide(slide16, slide2Images);

    // Energy Pie Chart
    const energyChartData = refs?.energyChart?.getDataForSlide();
    const { cityChunks } = energyChartData || [];
    if (cityChunks?.length > 0) {
      for (let chunkIndex = 0; chunkIndex < cityChunks.length; chunkIndex++) {
        const slide = pptx.addSlide();
        const legendElement = document.getElementById("energy-legends");
        const slideId = `${chunkIndex + 1}-energyChart`;
        const rowCount = cityChunks[chunkIndex]?.length;
        const chartHeight = calculateHeight1(rowCount); // Calculate height dynamically
        const chartElement = document.getElementById(`${slideId}`);
        if (legendElement) {
          try {
            const canvas = await html2canvas(legendElement, {
              scale: 2, // Increase scale for higher resolution
              useCORS: true, // Enable cross-origin resource sharing if needed
            });
            const imgData = canvas.toDataURL("image/png");
            slide.addImage({
              data: imgData,
              x: 0.21,
              y: 0.75,
              w: 9.3,
              h: 0.7,
            }); // Adjust the position and size as needed
          } catch (error) {
            console.error("Error capturing table as image:", error);
          }
        }
        if (chartElement) {
          try {
            const canvas = await html2canvas(chartElement, {
              scale: 2, // Increase scale for higher resolution
              useCORS: true, // Enable cross-origin resource sharing if needed
            });
            const imgData = canvas.toDataURL("image/png");
            slide.addImage({
              data: imgData,
              x: 0.28,
              y: 1.6,
              w: 9.52,
              h: 2.9,
            }); // Adjust the position and size as needed
          } catch (error) {
            console.error("Error capturing table as image:", error);
          }
        } else {
          console.error(`Table element with id '${slideId}' not found`);
        }
        await addImagesToSlide(slide, slide2Images);
        slide.addText(
          `Energy Consumption Breakdown : ${startdate} - ${enddate} `,
          {
            x: 0.5,
            y: 0.5,
            fontSize: 16,
            color: "#002060",
            bold: true,
          }
        );
        slide.addText("Copyright, Confidential, Tata Motors Limited", {
          x: 4,
          y: 5.37,
          fontSize: 8,
          color: "black",
        });
      }
    } else {
      // const slide = pptx.addSlide();
      const noDataElement = document.getElementById(`max_tem_no_data`);
      const slide = pptx.addSlide();
      if (noDataElement) {
        try {
          const canvas = await html2canvas(noDataElement, {
            scale: 2, // Increase scale for higher resolution
            useCORS: true, // Enable cross-origin resource sharing if needed
          });
          const imgData = canvas.toDataURL("image/png");
          slide.addImage({ data: imgData, x: 0.5, y: 1, w: 9.3, h: 2 }); // Adjust the position and size as needed
        } catch (error) {
          console.error("Error capturing table as image:", error);
        }
      } else {
        console.error(`not found`);
      }
      await addImagesToSlide(slide, slide2Images);
      slide.addText(
        `Pack wise max temperature vehicles (≥  ${props.selectedtemp} °C).`,
        { x: 0.5, y: 0.5, fontSize: 16, color: "#002060", bold: true }
      );
      slide.addText("Copyright, Confidential, Tata Motors Limited", {
        x: 4,
        y: 5.37,
        fontSize: 8,
        color: "black",
      });
    }

    // SLide Five
    const slide5 = pptx.addSlide();
    const pack_a_graph = document.querySelector("#pack_a");
    const pack_b_graph = document.querySelector("#pack_b");
    const pack_c_graph = document.querySelector("#pack_c");
    const pack_d_graph = document.querySelector("#pack_d");
    const pack_a_graph_no_data = document.querySelector("#pack_a_no_data");
    const pack_b_graph_no_data = document.querySelector("#pack_b_no_data");
    const pack_c_graph_no_data = document.querySelector("#pack_c_no_data");
    const pack_d_graph_no_data = document.querySelector("#pack_d_no_data");

    if (pack_a_graph) {
      try {
        const canvas = await html2canvas(pack_a_graph, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide5.addImage({ data: imgData, x: 0.39, y: 0.69, w: 4.2, h: 2.19 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    } else if (pack_a_graph_no_data) {
      try {
        const canvas = await html2canvas(pack_a_graph_no_data, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide5.addImage({ data: imgData, x: 0.39, y: 0.69, w: 4.2, h: 2 }); // Adjust the position and size as needed
      } catch (error) {
        console.error(
          "Error capturing NoData component for fault table as image:",
          error
        );
      }
    } else {
      console.error("Fault table element or NoData element not found");
    }
    if (pack_b_graph) {
      try {
        const canvas = await html2canvas(pack_b_graph, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide5.addImage({ data: imgData, x: 5.14, y: 0.69, w: 4.2, h: 2.19 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    } else if (pack_b_graph_no_data) {
      try {
        const canvas = await html2canvas(pack_b_graph_no_data, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide5.addImage({ data: imgData, x: 5.14, y: 0.69, w: 4.2, h: 2 }); // Adjust the position and size as needed
      } catch (error) {
        console.error(
          "Error capturing NoData component for fault table as image:",
          error
        );
      }
    } else {
      console.error("Fault table element or NoData element not found");
    }
    if (pack_c_graph) {
      try {
        const canvas = await html2canvas(pack_c_graph, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide5.addImage({ data: imgData, x: 0.39, y: 2.88, w: 4.2, h: 2.19 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    } else if (pack_c_graph_no_data) {
      try {
        const canvas = await html2canvas(pack_c_graph_no_data, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide5.addImage({ data: imgData, x: 0.39, y: 2.88, w: 4.2, h: 2.19 }); // Adjust the position and size as needed
      } catch (error) {
        console.error(
          "Error capturing NoData component for fault table as image:",
          error
        );
      }
    } else {
      console.error("Fault table element or NoData element not found");
    }
    if (pack_d_graph) {
      try {
        const canvas = await html2canvas(pack_d_graph, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide5.addImage({ data: imgData, x: 5.14, y: 2.88, w: 4.2, h: 2.19 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    } else if (pack_d_graph_no_data) {
      try {
        const canvas = await html2canvas(pack_d_graph_no_data, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide5.addImage({ data: imgData, x: 5.14, y: 2.88, w: 4.2, h: 2.19 }); // Adjust the position and size as needed
      } catch (error) {
        console.error(
          "Error capturing NoData component for fault table as image:",
          error
        );
      }
    } else {
      console.error("Fault table element or NoData element not found");
    }
    slide5.addText("Pack wise max temperature vs vehicle count :", {
      x: 0.5,
      y: 0.5,
      fontSize: 16,
      color: "#002060",
      bold: true,
    });
    slide5.addText(`${startdate} - ${enddate}`, {
      x: 4.77,
      y: 0.5,
      fontSize: 11,
      color: "black",
      bold: true,
    });
    slide5.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    await addImagesToSlide(slide5, slide2Images);

    // Slide Ten(FaultForthPart.js)
    const faultForthPartData = refs?.faultForthPart?.getDataForSlide();
    const { chunks3 } = faultForthPartData || [];
    const { toCalculateFaultCrit, critcal_duration } = faultForthPartData;
    if (chunks3?.length > 0) {
      for (let chunkIndex = 0; chunkIndex < chunks3.length; chunkIndex++) {
        const slide = pptx.addSlide();
        const slideId = `Crit-${chunkIndex}`;
        const critical_title = "crit_title";
        const rowCount = chunks3[chunkIndex]?.length;
        const tableHeight = calculateHeight1(rowCount); // Calculate height dynamically
        const tableElement = document.getElementById(`${slideId}`);
        const critTitle1Element = document.getElementById(`${critical_title}`);

        if (critTitle1Element) {
          try {
            const canvas = await html2canvas(critTitle1Element, {
              scale: 2, // Increase scale for higher resolution
              useCORS: true, // Enable cross-origin resource sharing if needed
            });
            const imgData = canvas.toDataURL("image/png");
            slide.addImage({
              data: imgData,
              x: 2.2,
              y: 0.7,
              w: 6.3,
              h: 0.3,
            }); // Adjust the position and size as needed
          } catch (error) {
            console.error("Error capturing table as image:", error);
          }
        }

        if (tableElement) {
          try {
            const canvas = await html2canvas(tableElement, {
              scale: 2, // Increase scale for higher resolution
              useCORS: true, // Enable cross-origin resource sharing if needed
            });
            const imgData = canvas.toDataURL("image/png");
            slide.addImage({
              data: imgData,
              x: 2,
              y: 1,
              w: 5.41,
              h: tableHeight,
            }); // Adjust the position and size as needed

            if (chunkIndex === chunks3.length - 1) {
              slide.addText(
                `Time Duration : ${critcal_duration?.toFixed(0)} `,
                {
                  x: 2.2,
                  y: tableHeight + 1,
                  fontSize: 10,
                  color: "#002060",
                  // bold: true,
                }
              );
              slide.addText(`Vehicle Count : ${toCalculateFaultCrit}`, {
                x: 6.3,
                y: tableHeight + 1,
                fontSize: 10,
                color: "#002060",

                // bold: true,
              });
            }
          } catch (error) {
            console.error("Error capturing table as image:", error);
          }
        } else {
          console.error(`Table element with id '${slideId}' not found`);
        }
        await addImagesToSlide(slide, slide2Images);
        slide.addText(`Faults Observed in Field : ${startdate} - ${enddate} `, {
          x: 0.5,
          y: 0.5,
          fontSize: 16,
          color: "#002060",
          bold: true,
        });
        slide.addText("Copyright, Confidential, Tata Motors Limited", {
          x: 4,
          y: 5.37,
          fontSize: 8,
          color: "black",
        });
      }
    } else {
      // const slide = pptx.addSlide();
      const noDataElement = document.getElementById(`faultfifth_no_data`);
      const slide = pptx.addSlide();
      if (noDataElement) {
        try {
          const canvas = await html2canvas(noDataElement, {
            scale: 2, // Increase scale for higher resolution
            useCORS: true, // Enable cross-origin resource sharing if needed
          });
          const imgData = canvas.toDataURL("image/png");
          slide.addImage({ data: imgData, x: 0.5, y: 1, w: 9.3, h: 2 }); // Adjust the position and size as needed
        } catch (error) {
          console.error("Error capturing table as image:", error);
        }
      } else {
        console.error(`not found`);
      }
      await addImagesToSlide(slide, slide2Images);
      slide.addText(`Faults Observed in Field : ${startdate} - ${enddate} `, {
        x: 0.5,
        y: 0.5,
        fontSize: 16,
        color: "#002060",
        bold: true,
      });
      slide.addText("Copyright, Confidential, Tata Motors Limited", {
        x: 4,
        y: 5.37,
        fontSize: 8,
        color: "black",
      });
    }

    // Slide Eleven(FaultFiftPart.js)
    const faultFifthPartData = refs?.faultFifthPart?.getDataForSlide();
    const bmsTitle1Element = document.querySelector("#bms_title");
    const { toCalculateFaultBMS, critcal_duration_fifth } = faultFifthPartData;
    const { chunks1 } = faultFifthPartData || [];
    if (chunks1?.length > 0) {
      for (let chunkIndex = 0; chunkIndex < chunks1.length; chunkIndex++) {
        const slide = pptx.addSlide();
        const slideId = `BMS-${chunkIndex}`;
        const bms_title = "bms_title";
        const rowCount = chunks1[chunkIndex]?.length;
        const tableHeight = calculateHeight1(rowCount); // Calculate height dynamically
        const tableElement = document.getElementById(`${slideId}`);
        const bmsTitle1Element = document.getElementById(`${bms_title}`);
        if (bmsTitle1Element) {
          try {
            const canvas = await html2canvas(bmsTitle1Element, {
              scale: 2, // Increase scale for higher resolution
              useCORS: true, // Enable cross-origin resource sharing if needed
            });
            const imgData = canvas.toDataURL("image/png");
            slide.addImage({
              data: imgData,
              x: 2.2,
              y: 0.7,
              w: 6.3,
              h: 0.3,
            }); // Adjust the position and size as needed
          } catch (error) {
            console.error("Error capturing table as image:", error);
          }
        }
        if (tableElement) {
          try {
            const canvas = await html2canvas(tableElement, {
              scale: 2, // Increase scale for higher resolution
              useCORS: true, // Enable cross-origin resource sharing if needed
            });
            const imgData = canvas.toDataURL("image/png");
            slide.addImage({
              data: imgData,
              x: 2,
              y: 1,
              w: 5.41,
              h: tableHeight,
            }); // Adjust the position and size as needed
            if (chunkIndex === chunks1.length - 1) {
              slide.addText(
                `Time Duration : ${critcal_duration_fifth?.toFixed(0)} `,
                {
                  x: 2.2,
                  y: tableHeight + 1,
                  fontSize: 10,
                  color: "#002060",
                  // bold: true,
                }
              );
              slide.addText(`Vehicle Count : ${toCalculateFaultBMS}`, {
                x: 6.3,
                y: tableHeight + 1,
                fontSize: 10,
                color: "#002060",

                // bold: true,
              });
            }
          } catch (error) {
            console.error("Error capturing table as image:", error);
          }
        } else {
          console.error(`Table element with id '${slideId}' not found`);
        }
        await addImagesToSlide(slide, slide2Images);
        slide.addText(`Faults Observed in Field : ${startdate} - ${enddate} `, {
          x: 0.5,
          y: 0.5,
          fontSize: 16,
          color: "#002060",
          bold: true,
        });
        slide.addText("Copyright, Confidential, Tata Motors Limited", {
          x: 4,
          y: 5.37,
          fontSize: 8,
          color: "black",
        });
      }
    } else {
      // const slide = pptx.addSlide();
      const noDataElement = document.getElementById(`faultfifth_no_data`);
      const slide = pptx.addSlide();
      if (noDataElement) {
        try {
          const canvas = await html2canvas(noDataElement, {
            scale: 2, // Increase scale for higher resolution
            useCORS: true, // Enable cross-origin resource sharing if needed
          });
          const imgData = canvas.toDataURL("image/png");
          slide.addImage({ data: imgData, x: 0.5, y: 1, w: 9.3, h: 2 }); // Adjust the position and size as needed
        } catch (error) {
          console.error("Error capturing table as image:", error);
        }
      } else {
        console.error(`not found`);
      }
      await addImagesToSlide(slide, slide2Images);
      slide.addText(`Faults Observed in Field : ${startdate} - ${enddate} `, {
        x: 0.5,
        y: 0.5,
        fontSize: 16,
        color: "#002060",
        bold: true,
      });
      slide.addText("Copyright, Confidential, Tata Motors Limited", {
        x: 4,
        y: 5.37,
        fontSize: 8,
        color: "black",
      });
    }

    // Slide Seven(FaultFirstPart.js)
    const slide7 = pptx.addSlide();
    const faultFirstPartData = refs.faultFirstPart.getDataForSlide();
    const {
      toCalculateFaultBCS1,
      toCalculateFaultBCS2,
      toCalculateFaultMCU,
      toCalculateFaultVCU,
      bms_duration_one,
      bms_duration_two,
      bms_duration_three,
      bms_duration_four,
    } = faultFirstPartData;
    const faultGraph1Title1ElementSlide7 = document.querySelector(
      "#faultfirstparttitlebcs1"
    );
    const faultGraph1Title2ElementSlide7 = document.querySelector(
      "#faultfirstparttitlebcs2"
    );
    const faultGraph1Title3ElementSlide7 = document.querySelector(
      "#faultfirstparttitlemcu"
    );
    const faultGraph1Title4ElementSlide7 = document.querySelector(
      "#faultfirstparttitlevcu"
    );
    const faultGraph1ElementSlide7 = document.querySelector(
      "#faultfirstpartbcs1"
    );
    const faultGraph2ElementSlide7 = document.querySelector(
      "#faultfirstpartbcs2"
    );
    const faultGraph3ElementSlide7 =
      document.querySelector("#faultfirstpartmcu");
    const faultGraph4ElementSlide7 =
      document.querySelector("#faultfirstpartvcu");

    if (faultGraph1Title1ElementSlide7) {
      try {
        const canvas = await html2canvas(faultGraph1Title1ElementSlide7, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide7.addImage({ data: imgData, x: 0.5, y: 0.8, w: 4.5, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph1Title2ElementSlide7) {
      try {
        const canvas = await html2canvas(faultGraph1Title2ElementSlide7, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide7.addImage({ data: imgData, x: 4.7, y: 0.8, w: 4.5, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph1Title3ElementSlide7) {
      try {
        const canvas = await html2canvas(faultGraph1Title3ElementSlide7, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide7.addImage({ data: imgData, x: 0.5, y: 2.5, w: 4.5, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph1Title4ElementSlide7) {
      try {
        const canvas = await html2canvas(faultGraph1Title4ElementSlide7, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide7.addImage({ data: imgData, x: 4.7, y: 2.5, w: 4.5, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }

    if (faultGraph1ElementSlide7) {
      try {
        const canvas = await html2canvas(faultGraph1ElementSlide7, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide7.addImage({ data: imgData, x: 0.5, y: 1.2, w: 4.5, h: 0.8 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph2ElementSlide7) {
      try {
        const canvas = await html2canvas(faultGraph2ElementSlide7, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide7.addImage({ data: imgData, x: 4.7, y: 1.2, w: 4.5, h: 1.1 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph3ElementSlide7) {
      try {
        const canvas = await html2canvas(faultGraph3ElementSlide7, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide7.addImage({ data: imgData, x: 0.5, y: 2.9, w: 4.5, h: 0.8 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph4ElementSlide7) {
      try {
        const canvas = await html2canvas(faultGraph4ElementSlide7, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide7.addImage({ data: imgData, x: 4.7, y: 2.8, w: 4.5, h: 2 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }

    slide7.addText(`Total time duration: ${bms_duration_one?.toFixed(0)}`, {
      x: 1.32,
      y: 2.07,
      fontSize: 10,
      color: "black",
    });
    slide7.addText(`Total vehicle count: ${toCalculateFaultBCS1}`, {
      x: 3.28,
      y: 2.07,
      fontSize: 10,
      color: "black",
    });
    slide7.addText(`Total time duration: ${bms_duration_two?.toFixed(0)}`, {
      x: 5.33,
      y: 2.19,
      fontSize: 10,
      color: "black",
    });
    slide7.addText(`Total vehicle count: ${toCalculateFaultBCS2}`, {
      x: 7.46,
      y: 2.19,
      fontSize: 10,
      color: "black",
    });
    slide7.addText(`Total time duration: ${bms_duration_three?.toFixed(0)}`, {
      x: 1.32,
      y: 3.7,
      fontSize: 10,
      color: "black",
    });
    slide7.addText(`Total vehicle count: ${toCalculateFaultMCU}`, {
      x: 3.28,
      y: 3.7,
      fontSize: 10,
      color: "black",
    });
    slide7.addText(`Total time duration: ${bms_duration_four?.toFixed(0)}`, {
      x: 5.33,
      y: 4.9,
      fontSize: 10,
      color: "black",
    });
    slide7.addText(`Total vehicle count: ${toCalculateFaultVCU}`, {
      x: 7.46,
      y: 4.9,
      fontSize: 10,
      color: "black",
    });

    slide7.addText("Faults Observed in Field:", {
      x: 0.5,
      y: 0.5,
      fontSize: 16,
      color: "#002060",
      bold: true,
    });
    slide7.addText(`${startdate} - ${enddate}`, {
      x: 2.75,
      y: 0.5,
      fontSize: 11,
      color: "black",
      bold: true,
    });
    slide7.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });

    await addImagesToSlide(slide7, slide2Images);

    // Slide Eight(FaultSecondPart.js)
    const slide8 = pptx.addSlide();
    const faulsecondpart = refs.faultsecondpart.getDataForSlide();
    const { hvac_duration, toCalculateFaultHVAC } = faulsecondpart;
    const { dcdc_duration, toCalculateFaultDCDC } = faulsecondpart;

    const faultGraphTitle1ElementSlide8 = document.querySelector(
      "#faultfirstparttitle_hvac"
    );
    const faultGraphTitle2ElementSlide8 = document.querySelector(
      "#faultfirstparttitle_dcdc"
    );
    const faultGraph1ElementSlide8 = document.querySelector(
      "#faultfirstpart_hvac"
    );
    const faultGraph2ElementSlide8 = document.querySelector(
      "#faultfirstpart_dcdc"
    );

    if (faultGraphTitle1ElementSlide8) {
      try {
        const canvas = await html2canvas(faultGraphTitle1ElementSlide8, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide8.addImage({ data: imgData, x: 0.5, y: 0.8, w: 4.5, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraphTitle2ElementSlide8) {
      try {
        const canvas = await html2canvas(faultGraphTitle2ElementSlide8, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide8.addImage({ data: imgData, x: 4.7, y: 0.8, w: 4.5, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph1ElementSlide8) {
      try {
        const canvas = await html2canvas(faultGraph1ElementSlide8, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide8.addImage({ data: imgData, x: 0.5, y: 1.2, w: 4.5, h: 3.8 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph2ElementSlide8) {
      try {
        const canvas = await html2canvas(faultGraph2ElementSlide8, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide8.addImage({ data: imgData, x: 4.7, y: 1.2, w: 4.5, h: 0.9 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }

    slide8.addText(`Total time duration: ${hvac_duration}`, {
      x: 0.5,
      y: 5,
      fontSize: 10,
      color: "black",
    });
    slide8.addText(`Total vehicle count: ${toCalculateFaultHVAC}`, {
      x: 2.5,
      y: 5,
      fontSize: 10,
      color: "black",
    });
    slide8.addText(`Total time duration: ${dcdc_duration}`, {
      x: 5,
      y: 2.1,
      fontSize: 10,
      color: "black",
    });
    slide8.addText(`Total vehicle count: ${toCalculateFaultDCDC}`, {
      x: 7,
      y: 2.1,
      fontSize: 10,
      color: "black",
    });
    slide8.addText(`Faults Observed in Field : ${startdate} - ${enddate} `, {
      x: 0.5,
      y: 0.5,
      fontSize: 16,
      color: "#002060",
      bold: true,
    });
    slide8.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    await addImagesToSlide(slide8, slide2Images);

    // Slide Nine(FaultThirdPart.js)
    const slide9 = pptx.addSlide();
    const faulthird_aux1 = refs.faultthirdpart.getDataForSlide();
    const { aux1_duration, toCalculateFaultAUX1 } = faulthird_aux1;
    const { aux2_duration, toCalculateFaultAUX2 } = faulthird_aux1;

    const faultGraphTitle1ElementSlide9 = document.querySelector(
      "#faultfirstparttitle_aux1"
    );
    const faultGraphTitle2ElementSlide9 = document.querySelector(
      "#faultfirstparttitle_aux2"
    );
    const faultGraph1ElementSlide9 = document.querySelector(
      "#faultfirstpart_aux1"
    );
    const faultGraph2ElementSlide9 = document.querySelector(
      "#faultfirstpart_aux2"
    );

    if (faultGraphTitle1ElementSlide9) {
      try {
        const canvas = await html2canvas(faultGraphTitle1ElementSlide9, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide9.addImage({ data: imgData, x: 0.5, y: 0.8, w: 4.5, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraphTitle2ElementSlide9) {
      try {
        const canvas = await html2canvas(faultGraphTitle2ElementSlide9, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide9.addImage({ data: imgData, x: 4.7, y: 0.8, w: 4.5, h: 0.351 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph1ElementSlide9) {
      try {
        const canvas = await html2canvas(faultGraph1ElementSlide9, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide9.addImage({ data: imgData, x: 0.5, y: 1.2, w: 4.5, h: 2.3 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }
    if (faultGraph2ElementSlide9) {
      try {
        const canvas = await html2canvas(faultGraph2ElementSlide9, {
          scale: 2,
          useCORS: true,
        });
        const imgData = canvas.toDataURL("image/png");
        slide9.addImage({ data: imgData, x: 4.7, y: 1.1, w: 4.5, h: 3.8 }); // Adjust the position and size as needed
      } catch (error) {
        console.error("Error capturing fault table as image:", error);
      }
    }

    slide9.addText(`Total time duration: ${aux1_duration}`, {
      x: 0.5,
      y: 3.5,
      fontSize: 10,
      color: "black",
    });
    slide9.addText(`Total vehicle count: ${toCalculateFaultAUX1}`, {
      x: 2.5,
      y: 3.5,
      fontSize: 10,
      color: "black",
    });
    slide9.addText(`Total time duration: ${aux2_duration}`, {
      x: 4.5,
      y: 4.9,
      fontSize: 10,
      color: "black",
    });
    slide9.addText(`Total vehicle count: ${toCalculateFaultAUX2}`, {
      x: 7.2,
      y: 4.9,
      fontSize: 10,
      color: "black",
    });

    slide9.addText(`Faults Observed in Field : ${startdate} - ${enddate} `, {
      x: 0.5,
      y: 0.5,
      fontSize: 16,
      color: "#002060",
      bold: true,
    });
    slide9.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    await addImagesToSlide(slide9, slide2Images);

    //Slide Six
    const pdfFifteenData = refs?.pdfFifteen?.getDataForSlide();
    const { chunks } = pdfFifteenData || [];
    if (chunks?.length > 0) {
      for (var chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
        const slide = pptx.addSlide();
        const slideId = `${chunkIndex + 1}st__table_formed`;
        const rowCount = chunks[chunkIndex]?.length;
        const tableHeight = calculateHeight(rowCount); // Calculate height dynamically
        const tableElement = document.getElementById(`${slideId}`);
        if (tableElement) {
          try {
            const canvas = await html2canvas(tableElement, {
              scale: 2, // Increase scale for higher resolution
              useCORS: true, // Enable cross-origin resource sharing if needed
            });
            const imgData = canvas.toDataURL("image/png");
            slide.addImage({
              data: imgData,
              x: 1.27,
              y: 0.84,
              w: 7.41,
              h: tableHeight,
            }); // Adjust the position and size as needed
          } catch (error) {
            console.error("Error capturing table as image:", error);
          }
        } else {
          console.error(`Table element with id '${slideId}' not found`);
        }
        await addImagesToSlide(slide, slide2Images);
        slide.addText(
          `Pack wise max temperature vehicles (≥  ${props.selectedtemp} °C).`,
          { x: 0.5, y: 0.5, fontSize: 16, color: "#002060", bold: true }
        );
        slide.addText("Copyright, Confidential, Tata Motors Limited", {
          x: 4,
          y: 5.37,
          fontSize: 8,
          color: "black",
        });
      }
    } else {
      // const slide = pptx.addSlide();
      const noDataElement = document.getElementById(`max_tem_no_data`);
      const slide = pptx.addSlide();
      if (noDataElement) {
        try {
          const canvas = await html2canvas(noDataElement, {
            scale: 2, // Increase scale for higher resolution
            useCORS: true, // Enable cross-origin resource sharing if needed
          });
          const imgData = canvas.toDataURL("image/png");
          slide.addImage({ data: imgData, x: 0.5, y: 1, w: 9.3, h: 2 }); // Adjust the position and size as needed
        } catch (error) {
          console.error("Error capturing table as image:", error);
        }
      } else {
        console.error(`not found`);
      }
      await addImagesToSlide(slide, slide2Images);
      slide.addText(
        `Pack wise max temperature vehicles (≥  ${props.selectedtemp} °C).`,
        { x: 0.5, y: 0.5, fontSize: 16, color: "#002060", bold: true }
      );
      slide.addText("Copyright, Confidential, Tata Motors Limited", {
        x: 4,
        y: 5.37,
        fontSize: 8,
        color: "black",
      });
    }

    // const slide6 = pptx.addSlide();
    // slide6.addText(
    //   `Pack wise max temperature vehicles (≥  ${props.selectedtemp} °C).`,
    //   { x: 0.5, y: 0.5, fontSize: 16, color: "#002060", bold: true }
    // );
    // slide6.addText("Copyright, Confidential, Tata Motors Limited", {
    //   x: 4,
    //   y: 5.37,
    //   fontSize: 8,
    //   color: "black",
    // });
    // await addImagesToSlide(slide6, slide2Images);

    // Slide crticaltable(CriticalTableLastPage.js)
    // debugger;
    const crticaltable = refs?.criticalLastPage?.getDataForSlide();
    const chunks2 = crticaltable?.criticalTableLastPage?.chunks2 || [];
    const vinArray = crticaltable?.topThreeVin;
    if (vinArray.length > 0) {
      // Iterate over each VIN
      for (let vinIndex = 0; vinIndex < vinArray.length; vinIndex++) {
        const vin = vinArray[vinIndex];
        // const vinChunks = chunks2?.length;
        const vinChunks =
          crticaltable.criticalTableLastPage[vinIndex].chunks2.length;

        for (let chunkIndex = 0; chunkIndex < vinChunks; chunkIndex++) {
          const slide = pptx.addSlide();
          const slideId = `${chunkIndex + 1}-vin-${vinIndex + 1}`;
          // const rowCount = chunks2[chunkIndex]?.length;
          let numberofrows =
            crticaltable.criticalTableLastPage[vinIndex].chunks2[chunkIndex]
              ?.length;
          // const getTableHeight = calculateHeight2(rowCount); // Calculate height dynamically
          const getTableHeight = calculateHeight2(numberofrows); // Calculate height dynamically
          const tableElement = document.getElementById(`${slideId}`);

          if (tableElement) {
            try {
              const canvas = await html2canvas(tableElement, {
                scale: 2,
                useCORS: true,
              });
              const imgData = canvas.toDataURL("image/png");
              const tableHeight = getTableHeight; // Calculate height dynamically

              slide.addImage({
                data: imgData,
                x: 0.58,
                y: 0.68,
                w: 9,
                h: tableHeight,
                // fontSize: 12,
              });
            } catch (error) {
              console.error("Error capturing table as image:", error);
            }
          } else {
            console.error(`Table element with id '${slideId}' not found`);
          }

          await addImagesToSlide(slide, slide2Images);
          slide.addText(`Details of Vehicles with Highest Operating Temp.`, {
            x: 0.5,
            y: 0.5,
            fontSize: 16,
            color: "#002060",
            bold: true,
          });
          slide.addText("Copyright, Confidential, Tata Motors Limited", {
            x: 4,
            y: 5.37,
            fontSize: 8,
            color: "black",
          });
          slide.addText(`Note: a) "-" indicates no data available.`, {
            x: 0.5,
            y: 4.7,
            fontSize: 10,
            color: "black",
          });
          slide.addText(
            `b) Max_Temp_Diff_Per_Day: Maximum of the Temperature difference observed between any two packs at instance.`,
            {
              x: 0.85,
              y: 4.9,
              fontSize: 10,
              color: "black",
            }
          );
          slide.addText(
            `c) Max_Temp Pack : Indicates the  Max_Temp_Diff_Per_Day occurs between which pack.`,
            {
              x: 0.85,
              y: 5.1,
              fontSize: 10,
              color: "black",
            }
          );
        }
      }
    } else {
      // Handle the case where no data is available
      const noDataElement = document.getElementById(`no-data-critical`);
      const slide = pptx.addSlide();

      if (noDataElement) {
        try {
          const canvas = await html2canvas(noDataElement, {
            scale: 2,
            useCORS: true,
          });
          const imgData = canvas.toDataURL("image/png");
          slide.addImage({ data: imgData, x: 0.5, y: 1, w: 9.3, h: 2 });
        } catch (error) {
          console.error("Error capturing no data element as image:", error);
        }
      } else {
        console.error("No data element not found");
      }

      await addImagesToSlide(slide, slide2Images);
      slide.addText(`Details of Vehicles with Highest Operating Temp.`, {
        x: 0.5,
        y: 0.5,
        fontSize: 16,
        color: "#002060",
        bold: true,
      });
      slide.addText("Copyright, Confidential, Tata Motors Limited", {
        x: 4,
        y: 5.37,
        fontSize: 8,
        color: "black",
      });
    }

    //Last Slide
    const slide20 = pptx.addSlide();
    slide20.addText("Copyright, Confidential, Tata Motors Limited", {
      x: 4,
      y: 5.37,
      fontSize: 8,
      color: "black",
    });
    await addImagesToSlide(slide20, slide4Images);
    await addImagesToSlide(slide20, slide3Images);

    pptx
      .writeFile({
        fileName: `CESL Performance Report (${startdate} to ${enddate}).pptx`,
      })
      .then(() => props?.setShowLoader(false));

    // pptx.writeFile({
    //   fileName: `CESL Performance Report (${startdate} to ${enddate}).pptx`,
    // });
    handleOff();
  };

  const handleOff = () => {
    setShowPdf(false);
    props.buttonDisable("false");
  };

  return (
    <div style={{ paddingTop: "50vh" }}>
      {/* {(showPdf) && */}
      <div ref={targetRef}>
        <>
          <div id="templatePage">
            <TemplatePage
              gloablfilter={gloablfilter}
              startdate={startdate}
              enddate={enddate}
              setRefs={setRefs}
            />
          </div>
          <div className="page-break"></div>

          <DriveAnalyticsPdf
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.driveAnalyticsPdf = ref)}
          />
          <div className="page-break"></div>
          <ChargeFifth
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.chargeFifth = ref)}
          />
          <div className="page-break"></div>
          <ChargeAnalyticsPdf
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.chargeAnalyticsPdf = ref)}
          />

          <div className="page-break"></div>
          <EnergyAnalyticsPdf
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.energyAnalytics = ref)}
          />
          <div className="page-break"></div>
          <EnergyChart
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.energyChart = ref)}
          />
          <PdfEigthPage
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
          />
          <div className="page-break"></div>
          <PdfFifteen
            gloablfilter={gloablfilter}
            selectTemp={props.selectedtemp}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.pdfFifteen = ref)}
            faultthirdpart
          />
          <div className="page-break"></div>
          <FaultFirstPart
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.faultFirstPart = ref)}
          />
          <div className="page-break"></div>
          <FaultSecondPart
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.faultsecondpart = ref)}
          />
          <div className="page-break"></div>
          <FaultThirdPart
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.faultthirdpart = ref)}
          />
          <FaultForthPart
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.faultForthPart = ref)}
          />
          <div className="page-break"></div>
          <FaultFifthPart
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.faultFifthPart = ref)}
          />
          <div className="page-break"></div>

          <Critical
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.criticalLastPage = ref)}
          />
          <div className="page-break"></div>
          <BubbleChart
            gloablfilter={gloablfilter}
            startdate={startdate}
            enddate={enddate}
            ref={(ref) => (refs.bubble = ref)}
          />
        </>
      </div>
      {/* } */}
    </div>
  );
}
